import './main.css';
import './highlight.css';
import { Elm } from './Main.elm';
import registerServiceWorker from './registerServiceWorker';

const elm = Elm.Main.init({
  node: document.getElementById('root')
});

registerServiceWorker();

elm.ports.setMetaContent.subscribe(pair => {
  const element = Array.prototype.find.call(document.querySelectorAll("meta"), e => e.getAttribute("name") === pair.name);
  if (element) {
    element.setAttribute("content", pair.content);
  } else {
    const meta = document.createElement("meta");
    meta.setAttribute("name", pair.name);
    meta.setAttribute("content", pair.content);
    document.querySelector("head").appendChild(meta);
  }
});

history.scrollRestoration = "manual";


// Feel odd on click internal link of markdown...

window.addEventListener("beforeunload", function (event) {

  const element = document.getElementById(location.href);
  if (element) {
    localStorage.setItem(`pageYOffset-${location.href}`, element.scrollTop);
  }
});

setTimeout(function () {
  if (localStorage.getItem(`pageYOffset-${location.href}`)) {
    const element = document.getElementById(location.href);
    if (element) {
      element.scroll(0, parseInt(localStorage.getItem(`pageYOffset-${location.href}`)));
    }
  }
}, 100);


setInterval(() => {
  const blocks = document.querySelectorAll("pre:not(.highlight-visited)");
  Array.prototype.forEach.call(blocks, block => {
    hljs.highlightBlock(block);
    block.classList.add("highlight-visited");
  })
}, 1000);


